//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheCustomScroll",
  props: {
    showTopScroll: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      contentWidth: 0, // Ширина контента для горизонтальной прокрутки
      isShowScroll: true
    };
  },
  mounted() {
    var self = this
    setTimeout(function () {
      self.setShowTopScroll()
    }, 100)

  },
  methods: {
    syncScrollEvent(source) {
      this.setShowTopScroll()
      const bottomScrollbar = this.$refs.bottomScrollbar.$el
      if(this.showTopScroll) {
        const topScrollbar = this.$refs.topScrollbar.$el

        if (source === 'topScrollbar') {
          bottomScrollbar.scrollLeft = topScrollbar.scrollLeft
        } else if (source === 'bottomScrollbar') {
          topScrollbar.scrollLeft = bottomScrollbar.scrollLeft
        }
      }

      this.$emit('horizontal-handler', bottomScrollbar.scrollLeft);
    },
    setShowTopScroll(){
      var self = this
      const bottomScrollbar = self.$refs?.bottomScrollbar?.$el
      if(bottomScrollbar?.firstChild?.scrollWidth) {
        self.contentWidth = bottomScrollbar?.firstChild?.scrollWidth
        self.isShowScroll = bottomScrollbar?.firstChild?.clientWidth >= bottomScrollbar?.clientWidth
      }
    }
  }
}
